import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { Dynamic, type DynamicAction } from '@shared/registry/dynamic';

import { type DaySwitcherConfig } from './day-switcher.types';

@Component({
  selector: 'app-day-switcher',
  templateUrl: './day-switcher.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Dynamic],
})
export class DaySwitcher {
  readonly config = input.required<DaySwitcherConfig>();

  readonly action = output<DynamicAction>();

  protected readonly formattedDate = computed(() => {
    const date = new Date(this.config().date);
    return date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  });

  protected onPrevious(): void {
    this.action.emit({ id: 'previous' });
  }

  protected onNext(): void {
    this.action.emit({ id: 'next' });
  }

  protected onDateClick(): void {
    this.action.emit({ id: 'dateClick' });
  }
}
